export class ArrayUtil {
	static containsStringInArray(list: string[], text: string) {
		return Array.isArray(list) && list.some(url => text.includes(url));
	}
}
